import React, { useEffect, createRef } from "react";
import ImagePattern from "../../images/challenge-pattern.svg";
import InView from "react-intersection-observer";
import lottie from 'lottie-web';
import animation from '../../icons/svg_animations/Path-Animation-challenge/PathAnimationChallenge.json';

export default function Intro() {
  let animationContainer = createRef();
  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation
    });
  }, []);
  return (
    <InView>
      <div className="cs-challege-section section-gap po-cs-challege-section">
        <div className="cs-challege-wrapper">
          <div className="container">
            <div className="challege-inner">
              <h3 className="h3">The Challenge</h3>
              <p>The orthopedic, sports medicine, and physical therapy providers struggle to improve patients' behavior to comply with physical therapy routines correctly and adequately when not at the clinic. When at home, many patients fail to take good care of themselves actively, do their routine exercises, and check with providers as advised. In addition, every patient and their injuries are different, and the path to recovery is also different. Along with the patients, the companies that employ them also suffer from continuous loss of productivity and money. </p>

              <p>PhysioOutcomes team understood and empathized with the above challenges and partnered with Rapidops to discover, design, and deliver a mobile-first and HIPAA compliant MSK recovery platform to improve patients’ participation in their recovery with hyper-personalized education and connected care.</p>
            </div>
          </div>
          <div className="challege-pattern">
              <div><div className="path-animation-challenge-container" ref={animationContainer} /></div>
          </div>
        </div>
      </div>
    </InView>
  );
}